"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.default = void 0;
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _redux = require("redux");
var _reselect = require("reselect");
var _injectSaga = _interopRequireDefault(require("cornerstone_ui_core/lib/utils/injectSaga"));
var _injectReducer = _interopRequireDefault(require("cornerstone_ui_core/lib/utils/injectReducer"));
var _baseLayout = require("./base-layout.actions");
var _baseLayout2 = require("./base-layout.constants");
var _baseLayout3 = require("./base-layout.selectors");
var _baseLayout4 = _interopRequireDefault(require("./base-layout.reducer"));
var _baseLayout5 = _interopRequireDefault(require("./base-layout.saga"));
var _BaseLayout = _interopRequireDefault(require("./BaseLayout"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const mapDispatchToProps = dispatch => ({
  getUserGridColumns: key => {
    dispatch((0, _baseLayout.getUserGridColumns)(key));
  },
  applyUserGridSettings: (gridKey, userGridColumnList) => {
    dispatch((0, _baseLayout.applyUserGridSettings)(gridKey, userGridColumnList));
  },
  setLoading: loadingFlag => {
    dispatch((0, _baseLayout.loading)(loadingFlag));
  },
  sideNavToggle: () => {
    dispatch((0, _baseLayout.sideNavToggle)());
  },
  findByUserAppAndFunctions: (appName, userId) => {
    dispatch((0, _baseLayout.findByUserAppAndFunctions)(appName, userId));
  },
  fetchJwttokenSN: (userId, appName, decoded) => {
    dispatch((0, _baseLayout.fetchJwttokenSN)(userId, appName, decoded));
  },
  getUserSession: cacheKey => {
    dispatch((0, _baseLayout.getUserSession)(cacheKey));
  },
  getPersonaUser: (userId, appName) => {
    dispatch((0, _baseLayout.getPersonaUser)(userId, appName));
  },
  performEsignAuth: (0, _baseLayout.dispatchService)(dispatch, "performEsignAuth"),
  findByUserApps: (0, _baseLayout.dispatchService)(dispatch, "findByUserApps")
});
exports.mapDispatchToProps = mapDispatchToProps;
const mapStateToProps = (0, _reselect.createStructuredSelector)({
  authenticated: (0, _baseLayout3.makeSelectAuthenticated)(),
  loading: (0, _baseLayout3.makeSelectLoading)(),
  user: (0, _baseLayout3.makeSelectUserInfo)(),
  entitlementStatus: (0, _baseLayout3.makeSelectEntitlementStatus)(),
  showTodo: (0, _baseLayout3.makeSelectShowTodo)(),
  eXJwtToken: (0, _baseLayout3.makeSelectJwtTokenSN)(),
  userSession: (0, _baseLayout3.makeSelectUserSession)(),
  userPersonaList: (0, _baseLayout3.makeSelectUserPersona)(),
  adaSetting: (0, _baseLayout3.makeSelectAdaSetting)()
});
const withConnect = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps);
const withSaga = (0, _injectSaga.default)({
  key: _baseLayout2.key,
  saga: _baseLayout5.default
});
const withReducer = (0, _injectReducer.default)({
  key: _baseLayout2.key,
  reducer: _baseLayout4.default
});
var _default = exports.default = (0, _redux.compose)(withReducer, withSaga, _reactRouterDom.withRouter, withConnect)(_BaseLayout.default);